const AnalysisIcon = ({ size = 24, className = "", isActive = false, ...props }) => {
  const bgFill = isActive ? "#68D7FF" : "#9EA6B2";
  const bgFillOpacity = isActive ? 0.2 : 0.3;
  const pathFill = isActive ? "#01BBFE" : "white";
  const gradientId = isActive ? "blue-gradient" : "white-gradient";
  const gradientColor = isActive ? "#68D7FF" : "white";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect x="1" y="1" width="54" height="54" rx="27" fill={bgFill} fillOpacity={bgFillOpacity} />
      <rect x="1" y="1" width="54" height="54" rx="27" stroke={`url(#${gradientId})`} strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 35.8512C16 35.4719 16.3075 35.1643 16.6869 35.1643H39.3131C39.6925 35.1643 40 35.4719 40 35.8512V37.3131C40 37.6925 39.6925 38 39.3131 38H16.6869C16.3075 38 16 37.6925 16 37.3131V35.8512ZM17.9354 28.928C17.5561 28.928 17.2485 29.2355 17.2485 29.6149V33.5072C17.2485 33.8866 17.5561 34.1941 17.9354 34.1941H19.6877C20.067 34.1941 20.3746 33.8866 20.3746 33.5072V29.6149C20.3746 29.2355 20.067 28.928 19.6877 28.928L17.9354 28.928ZM35.5555 18.3435C35.5555 18.1538 35.7092 18 35.8989 18H38.3381C38.5278 18 38.6815 18.1538 38.6815 18.3435V33.8507C38.6815 34.0403 38.5278 34.1941 38.3381 34.1941H35.8989C35.7092 34.1941 35.5555 34.0403 35.5555 33.8507V18.3435ZM29.4532 24.0613C29.4532 23.6819 29.7607 23.3744 30.1401 23.3744H31.8923C32.2717 23.3744 32.5792 23.6819 32.5792 24.0613V33.5072C32.5792 33.8866 32.2717 34.1941 31.8923 34.1941H30.1401C29.7607 34.1941 29.4532 33.8866 29.4532 33.5072V24.0613ZM23.3508 27.286C23.3508 26.9066 23.6584 26.5991 24.0377 26.5991H25.79C26.1693 26.5991 26.4769 26.9066 26.4769 27.286V33.5072C26.4769 33.8866 26.1693 34.1941 25.79 34.1941H24.0377C23.6584 34.1941 23.3508 33.8866 23.3508 33.5072V27.286Z"
        fill={pathFill}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="3.95297"
          y1="4.40429"
          x2="50.7637"
          y2="54.4557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientColor} />
          <stop offset="1" stopColor={gradientColor} stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AnalysisIcon;
